module.exports = __webpack_public_path__ + "static/img/BU02PB-3.9bb9216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02PB-3.jpg
// module id = 3ysq
// module chunks = 1